<header class="main__content__header modal-header">
  <h2 class="modal-title">Alterar imagem do perfil</h2>
  <a class="header__btn__close" (click)="activeModal.close(true)">
    <span aria-hidden="true">X</span>
  </a>
</header>
<main class="main__content__modal modal-body">
  <ngx-dropzone (change)="fileChangeEvent($event)" [multiple]="false" *ngIf="imageBase64==''">
    <ngx-dropzone-label>Upload de Imagem!</ngx-dropzone-label>
  </ngx-dropzone>
  <image-cropper *ngIf="imageBase64!=''" [imageBase64]="imageBase64" (imageCropped)="imageCropped($event)"
    [resizeToWidth]="128" [cropperMinWidth]="128" format="png" [onlyScaleDown]="true" [roundCropper]="true"
    (loadImageFailed)="evento()">
  </image-cropper>
</main>
<footer class="main__content__footer modal-footer">
  <div class="float-right bottom-sixteen mt-3">
    <button class="btn btn-outline-primary right-sixteen" type="button" (click)="activeModal.dismiss('Cross click')">
      Cancelar
    </button>
    <button class="btn btn-primary ml-1" type="button" (click)='changeImg()' [disabled]="imageBase64==''">
      Alterar Imagem
    </button>
  </div>
</footer>